<div class="manage-recipient">
  <np-add-beneficiary-step></np-add-beneficiary-step>

  <div class="col-md-10 offset-md-1">
    <div class="receipient-header">
      <ng-container *ngIf="action !== addRecipientFrom.Bank">
        <strong>Add new beneficiary | </strong>Beneficiary information
      </ng-container>
      <ng-container *ngIf="action === addRecipientFrom.Bank">
        <strong>Bank Account Details | </strong>Bank information
      </ng-container>
    </div>
  </div>

  <div class="col-sm-12 col-md-4 offset-md-4">
    <form [formGroup]="formStep1" (ngSubmit)="submitFromStep1()">
      <ng-container *ngIf="action !== addRecipientFrom.Bank">
        <div class="row form-group">
          <mat-form-field [ngClass]="{
            'is-valid': formStep1.get('recipientName').valid && !formStep1.hasError('numberOfWordBeneficiaryName') && formStep1.get('recipientName').touched,
            'is-invalid': (!formStep1.get('recipientName').valid || formStep1.hasError('numberOfWordBeneficiaryName')) && formStep1.get('recipientName').touched
          }">
            <input matInput placeholder="Full legal name of beneficiary" formControlName="recipientName" class="no-upscope"/>
          </mat-form-field>
          <div class="error-message" *ngIf="formStep1.get('recipientName').hasError('required') && formStep1.get('recipientName').touched">
            Please input valid information here
          </div>
          <div class="error-message" *ngIf="formStep1.get('recipientName').valid && formStep1.hasError('numberOfWordBeneficiaryName') && formStep1.get('recipientName').touched">
            Please include first and last names in the Beneficiary name
          </div>
          <div class="error-message" *ngIf="formStep1.get('recipientName').hasError('pattern') && formStep1.get('recipientName').touched">
            <np-swift-character-message></np-swift-character-message>
          </div>
        </div>

        <div class="row form-group">
          <mat-form-field [ngClass]="{
                  'is-valid': formStep1.get('beneType').valid && formStep1.get('beneType').touched,
                  'is-invalid': !formStep1.get('beneType').valid && formStep1.get('beneType').touched
                }">
            <mat-select placeholder="Beneficiary Type" formControlName="beneType">
              <mat-option *ngFor="let beneType of beneTypes" [value]="beneType.id">
                <span>{{beneType.name}}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="error-message" *ngIf="!formStep1.get('beneType').valid && formStep1.get('beneType').touched">
            Please input valid information here
          </div>
        </div>
      </ng-container>

      <div class="row form-group">
        <np-mat-autocomplete-hybrid 
          dataDisplayValue="name" [selectControl]="formStep1.get('country')" 
          placeholder="{{ action !== addRecipientFrom.Bank ? 'Bank Country' : 'Country'}}"
          [data]="countries" inputClass="capitalize-field" (selecteOptionChanged)="checkRequiredBeneficiaryDetails(); checkRequiredStateProvince()"></np-mat-autocomplete-hybrid>
      </div>

      <ng-container *ngIf="action !== addRecipientFrom.Bank">
        <div class="row form-group">
          <mat-form-field [ngClass]="{
                'is-valid': formStep1.get('recipientAddress1').valid && formStep1.get('recipientAddress1').touched,
                'is-invalid': !formStep1.get('recipientAddress1').valid && formStep1.get('recipientAddress1').touched
              }">
            <input matInput placeholder="Beneficiary Address 1" formControlName="recipientAddress1" maxlength="35">
          </mat-form-field>
          <div class="error-message" *ngIf="formStep1.get('recipientAddress1').hasError('required') && formStep1.get('recipientAddress1').touched">
            Please input information here
          </div>
          <div class="error-message" *ngIf="formStep1.get('recipientAddress1').hasError('maxlength') && formStep1.get('recipientAddress1').touched">
            Maximum of 35 characters
          </div>
          <div class="error-message"
            *ngIf="formStep1.get('recipientAddress1').hasError('pattern') && formStep1.get('recipientAddress1').touched">
            <np-swift-character-message></np-swift-character-message>
          </div>
        </div>
        <div class="row form-group">
          <mat-form-field [ngClass]="{
                'is-valid': formStep1.get('recipientAddress2').valid && formStep1.get('recipientAddress2').touched,
                'is-invalid': !formStep1.get('recipientAddress2').valid && formStep1.get('recipientAddress2').touched
              }">
            <input matInput placeholder="Beneficiary Address 2" formControlName="recipientAddress2" maxlength="35">
          </mat-form-field>
          <div class="error-message" *ngIf="formStep1.get('recipientAddress2').hasError('maxlength') && formStep1.get('recipientAddress2').touched">
            Maximum of 35 characters
          </div>
          <div class="error-message"
            *ngIf="formStep1.get('recipientAddress2').hasError('pattern') && formStep1.get('recipientAddress2').touched">
            <np-swift-character-message></np-swift-character-message>
          </div>
        </div>

        <div class="row form-group">
          <mat-form-field [ngClass]="{
                        'is-valid': formStep1.get('beneCity').valid && formStep1.get('beneCity').touched,
                        'is-invalid': !formStep1.get('beneCity').valid && formStep1.get('beneCity').touched
                      }">
            <input matInput placeholder="Beneficiary City" formControlName="beneCity" maxlength="60">
          </mat-form-field>
          <div class="error-message"
            *ngIf="formStep1.get('beneCity').hasError('required') && formStep1.get('beneCity').touched">
            Please input information here
          </div>
          <div class="error-message"
            *ngIf="formStep1.get('beneCity').hasError('maxlength') && formStep1.get('beneCity').touched">
            Maximum of 60 characters
          </div>
          <div class="error-message"
            *ngIf="formStep1.get('beneCity').hasError('pattern') && formStep1.get('beneCity').touched">
            <np-swift-character-message></np-swift-character-message>
          </div>
        </div>

        <div class="row form-group">
          <mat-form-field [ngClass]="{
                        'is-valid': formStep1.get('beneState').valid && formStep1.get('beneState').touched,
                        'is-invalid': !formStep1.get('beneState').valid && formStep1.get('beneState').touched
                      }">
            <input matInput placeholder="Beneficiary State Or Province" formControlName="beneState"  maxlength="50">
          </mat-form-field>
          <div class="error-message" *ngIf="formStep1.get('beneState').hasError('required') && formStep1.get('beneState').touched">
            Please input information here
          </div>
          <div class="error-message" *ngIf="formStep1.get('beneState').hasError('maxlength') && formStep1.get('beneState').touched">
            Maximum of 50 characters
          </div>
          <div class="error-message" *ngIf="formStep1.get('beneState').hasError('pattern') && formStep1.get('beneState').touched">
            <np-swift-character-message></np-swift-character-message>
          </div>
        </div>

        <div class="row form-group">
          <mat-form-field [ngClass]="{
                        'is-valid': formStep1.get('benePostCode').valid && formStep1.get('benePostCode').touched,
                        'is-invalid': !formStep1.get('benePostCode').valid && formStep1.get('benePostCode').touched
                      }">
            <input matInput placeholder="Beneficiary Post Code" formControlName="benePostCode" maxlength="12">
          </mat-form-field>
          <div class="error-message" *ngIf="formStep1.get('benePostCode').hasError('required') && formStep1.get('benePostCode').touched">
            Please input information here
          </div>
          <div class="error-message"
            *ngIf="formStep1.get('benePostCode').hasError('maxlength') && formStep1.get('benePostCode').touched">
            Maximum of 12 characters
          </div>
          <div class="error-message" *ngIf="formStep1.get('benePostCode').hasError('pattern') && formStep1.get('benePostCode').touched">
            <np-swift-character-message></np-swift-character-message>
          </div>
        </div>

        <div class="row form-group">
            <np-mat-autocomplete-hybrid dataDisplayValue="name" [selectControl]="formStep1.get('recipientCountry')"
              placeholder="Beneficiary Country" [data]="countries"
              inputClass="capitalize-field"></np-mat-autocomplete-hybrid>
        </div>

        <div class="row form-group">
          <mat-form-field [ngClass]="{
                                'is-valid': formStep1.get('beneTaxId').valid && formStep1.get('beneTaxId').touched,
                                'is-invalid': !formStep1.get('beneTaxId').valid && formStep1.get('beneTaxId').touched
                              }">
            <input matInput placeholder="Beneficiary Tax ID" formControlName="beneTaxId">
          </mat-form-field>
          <div class="error-message" *ngIf="formStep1.get('beneTaxId').hasError('required') && formStep1.get('beneTaxId').touched">
            Please input valid information here
          </div>
          <div class="error-message"
            *ngIf="formStep1.get('beneTaxId').hasError('pattern') && formStep1.get('beneTaxId').touched">
            <np-swift-character-message></np-swift-character-message>
          </div>
        </div>
      </ng-container>

      <div class="row form-group">
        <np-mat-autocomplete-hybrid dataDisplayValue="code" [selectControl]="formStep1.get('currency')"
          placeholder="Currency" [data]="currencies" [readonly]="action === addRecipientFrom.SendPayment"
          inputClass="input-upper-case" (selecteOptionChanged)="checkRequiredBeneficiaryDetails()"></np-mat-autocomplete-hybrid>
      </div>

      <ng-container *ngIf="action !== addRecipientFrom.Bank">
        <div class="row form-group">
          Are you paying someone else? Would you like us to send them an email notification?
        </div>
        <div class="row my-4">
          <mat-radio-group formControlName="notification">
            <mat-radio-button disableRipple value="yes" (click)="focusYes()">Yes</mat-radio-button>
            <mat-radio-button disableRipple value="no" (click)="focusNo()">No</mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="row form-group" *ngIf="showEmail">
          <mat-form-field [ngClass]="{
            'is-valid': formStep1.get('email').valid && formStep1.get('email').touched,
            'is-invalid': !formStep1.get('email').valid && formStep1.get('email').touched
          }">
            <input matInput formControlName="email" placeholder="Beneficiary email" />
          </mat-form-field>
          <div class="error-message" *ngIf="formStep1.get('email').hasError('required') && formStep1.get('email').touched">
            Please input valid information here
          </div>
          <div class="error-message" *ngIf="formStep1.get('email').hasError('email') && formStep1.get('email').touched">
            Please enter a valid email address
          </div>
        </div>
      </ng-container>

      <div class="row form-group">
        <div class="col-6 pl-0">
          <button type="button" class="btn btn-lg btn-block btn-greengo-o" (click)="cancel()">
            Back
          </button>
        </div>
        <div class="col-6 pr-0">
          <button class="btn btn-lg btn-block" type="submit" [ngClass]="{
            'btn-greengo': formStep1.valid,
            'btn-inactive': !formStep1.valid
          }">Continue</button>
        </div>
      </div>
    </form>
  </div>
</div>